import { apiFetch } from "@/client/lib/api";
import type { TicketSummary } from "@/client/features/tickets/tickets-api";
import type { StorageTierId } from "@/shared/storage-tiers";

export interface StorageRequestInput {
  tier: StorageTierId;
  notes?: string;
}

export const storageApi = {
  request: (input: StorageRequestInput) =>
    apiFetch<TicketSummary>("/storage/request", { method: "POST", json: input }),
};
